export function roundRect(canvas, x, y, width, height, radius, fill, stroke) {
    if (typeof radius === 'undefined') {
        radius = 5;
    }
    if (typeof radius === 'number') {
        radius = { tl: radius, tr: radius, br: radius, bl: radius };
    }
    else {
        var defaultRadius = { tl: 0, tr: 0, br: 0, bl: 0 };
        for (var side in defaultRadius) {
            radius[side] = radius[side] || defaultRadius[side];
        }
    }
    canvas.beginPath();
    canvas.moveTo(x + radius.tl, y);
    canvas.lineTo(x + width - radius.tr, y);
    canvas.quadraticCurveTo(x + width, y, x + width, y + radius.tr);
    canvas.lineTo(x + width, y + height - radius.br);
    canvas.quadraticCurveTo(x + width, y + height, x + width - radius.br, y + height);
    canvas.lineTo(x + radius.bl, y + height);
    canvas.quadraticCurveTo(x, y + height, x, y + height - radius.bl);
    canvas.lineTo(x, y + radius.tl);
    canvas.quadraticCurveTo(x, y, x + radius.tl, y);
    canvas.closePath();
    if (fill) {
        canvas.fillStyle(fill);
        canvas.fill();
    }
    if (stroke) {
        canvas.ctx.strokeStyle = stroke;
        canvas.ctx.stroke();
    }
}
